'use client';
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    TagGroupContext: function() {
        return TagGroupContext;
    },
    TagGroupContextProvider: function() {
        return TagGroupContextProvider;
    },
    useTagGroupContext_unstable: function() {
        return useTagGroupContext_unstable;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const TagGroupContext = /*#__PURE__*/ _react.createContext(undefined);
const tagGroupContextDefaultValue = {
    handleTagDismiss: ()=>({}),
    size: 'medium',
    role: 'toolbar',
    handleTagSelect: undefined
};
const TagGroupContextProvider = TagGroupContext.Provider;
const useTagGroupContext_unstable = ()=>{
    var _React_useContext;
    return (_React_useContext = _react.useContext(TagGroupContext)) !== null && _React_useContext !== void 0 ? _React_useContext : tagGroupContextDefaultValue;
};
